export interface IDeclaredValueResponse {
  readonly declaredValues: IDeclaredValueFingerprint;
  readonly declaredValuesPack: IDeclaredValuePackFingerprint;
}

export interface IDeclaredValueFingerprint {
  readonly dt: IDeclaredValues;
  readonly fp: string;
}
export interface IDeclaredValuePackFingerprint {
  readonly dt: IDeclaredValuesPack;
  readonly fp: string;
}

export interface IDeclaredValues {
  readonly cp?: number;
  readonly ct?: string;
  readonly dr?: IDeclaredValue[];
  readonly mo?: string;
  readonly svc?: string;
  readonly tp?: number;
}

export interface IDeclaredValuesPack {
  readonly ct?: string;
  readonly dr?: IDeclaredValuePack[];
  readonly mo: string;
  readonly svc?: string;
}

export interface IDeclaredValue {
  readonly co?: string;
  readonly ct?: IContainer[];
  readonly vl?: IValue[];
}

export interface IDeclaredValuePack {
  readonly co?: string;
  readonly vl?: IValuePack[];
}

export interface IValue {
  am?: number;
  bc?: string;
  cic?: string;
  ctc?: string;
  sc?: string;
}

export interface IValuePack {
  cic?: string;
  ctc?: string;
  pc?: string;
  pq?: number;
}

export interface IContainer {
  bc?: string;
  sc?: string;
}

export enum COMMODITY_TYPES {
  BILL = "1",
  COIN = "2",
  CASH = "0",
}

export interface ILimitExceeded {
  currency: string;
  import: number;
  limitValue?: number;
}
